module.exports = __webpack_public_path__ + "static/img/wap.24a020b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/小学/wap.svg
// module id = VI7V
// module chunks = 16